import { Controller } from "@hotwired/stimulus"

const SMS_LENGTH = 70

export default class extends Controller {
  static targets = ["textarea", "counter"]

  connect() {
    this.update()
  }

  update() {
    const count = this.countChars(this.textareaTarget.value)
    const over = count > SMS_LENGTH

    if (count === 0) {
      this.counterTarget.textContent = `Символов: 0 · 0 сообщений`
      this.counterTarget.classList.remove("text-danger")
      this.counterTarget.classList.add("text-muted")
    } else if (over) {
      const messages = Math.ceil(count / SMS_LENGTH)
      this.counterTarget.textContent = `Символов: ${count} · ${messages} ${this.pluralMessages(messages)}`
      this.counterTarget.classList.add("text-danger")
      this.counterTarget.classList.remove("text-muted")
    } else {
      this.counterTarget.textContent = `Символов: ${count} · 1 сообщение`
      this.counterTarget.classList.remove("text-danger")
      this.counterTarget.classList.add("text-muted")
    }
  }

  countChars(text) {
    const urlRegex = /https?:\/\/[^\s]+/g
    let count = text.length
    let match
    while ((match = urlRegex.exec(text)) !== null) {
      count -= match[0].length
      count += 12
    }
    return count
  }

  pluralMessages(n) {
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) return "сообщение"
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "сообщения"
    return "сообщений"
  }
}
